import React from 'react';

import { Alert, Box, List, ListItem, Stack, Typography } from '@mui/material';

import { definitions } from '@luxuryescapes/contract-svc-promo';

type DiscountResponseItem = definitions['Discount Response']['promo']['items'][0];
type Travellers = NonNullable<DiscountResponseItem['travellers']>;
type Traveller = Travellers extends Array<infer T> ? T : Travellers;

type TravellersListProps = {
  travellers?: Array<Traveller> | Traveller;
  withTitle?: boolean;
};
function TravellersList({ travellers, withTitle = true }: TravellersListProps) {
  if (!travellers) {
    return <Alert severity="warning">Travellers not available</Alert>;
  }

  const title = <Typography fontWeight="bold">Travellers: </Typography>;
  if (Array.isArray(travellers)) {
    return (
      <Stack direction="column">
        {withTitle && title}
        {travellers.map((t, i) => (
          <Box key={i}>
            {t.firstName} {t.lastName}
          </Box>
        ))}
      </Stack>
    );
  }

  return (
    <List>
      {withTitle && title}
      <ListItem>
        {travellers.firstName} {travellers.lastName}
      </ListItem>
    </List>
  );
}

export default TravellersList;
